import { gql } from '@apollo/client';

// ===================================================================
// Read Queries: Product catalog, order history, shipping, coupons
// ===================================================================

export const GET_DEVICE_PRODUCTS = gql`
  query GetDeviceProducts {
    getDeviceProducts {
      _id
      name
      image
      price
      prices
      description
      configWifi
      configTimeZone
      isActive
      variant_id
      isKiosk
      main
      isLimitFreeDeviceCoupon
      promoTag
      alias
      images
      amazonStores
      link
      addOns
    }
  }
`;

export const GET_DEVICE_ORDERS = gql`
  query GetDeviceOrders($limit: Float, $offset: Float) {
    getDeviceOrders(limit: $limit, offset: $offset) {
      items {
        _id
        apiOrderId
        accountId
        total
        items
        shipping
        billing
        deliveryMethod
        card
        tax
        currency
        isAllowEdit
        createdAt
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const GET_DEVICE_SHIPPINGS = gql`
  query GetDeviceShippings {
    getDeviceShippings {
      _id
      name
      isActive
      prices
    }
  }
`;

export const GET_ACCOUNT_DEVICE_COUPONS = gql`
  query GetAccountDeviceCoupons {
    getAccountDeviceCoupons {
      _id
      coupon
      deviceFreeId
      couponUsed
      couponNumber
      totalChargeSub
      price
      status
      expiredAt
    }
  }
`;

// ===================================================================
// Phase 1: Validation & Lookup Queries
// ===================================================================

export const VALIDATE_FREE_DEVICE_EMAIL = gql`
  query ValidateFreeDeviceEmail($email: String!, $isNewCustomer: Boolean) {
    validateFreeDeviceEmail(email: $email, isNewCustomer: $isNewCustomer)
  }
`;

export const GET_DEVICE_ORDER_INVOICE = gql`
  query GetDeviceOrderInvoice($invoiceId: String!) {
    getDeviceOrderInvoice(invoiceId: $invoiceId)
  }
`;

export const GET_US_ADDRESS_BY_ZIP_CODE = gql`
  query GetUSAddressByZipCode($zipcode: String!) {
    getUSAddressByZipCode(zipcode: $zipcode)
  }
`;

export const GET_DEVICE_COUPON = gql`
  query GetDeviceCoupon($input: GetDeviceCouponInput!) {
    getDeviceCoupon(input: $input)
  }
`;

// ===================================================================
// Mutations: Invoice draft, checkout, order creation
// ===================================================================

export const CREATE_DEVICE_INVOICE_DRAFT = gql`
  mutation CreateDeviceInvoiceDraft($input: CreateDeviceInvoiceDraftInput!) {
    createDeviceInvoiceDraft(input: $input)
  }
`;

export const CONFIRM_DEVICE_CHECKOUT = gql`
  mutation ConfirmDeviceCheckout($sessionId: String!) {
    confirmDeviceCheckout(sessionId: $sessionId)
  }
`;

export const CREATE_DEVICE_ORDER = gql`
  mutation CreateDeviceOrder($params: JSONObject!) {
    createDeviceOrder(params: $params)
  }
`;
